<div class="navbar-area" ngStickyNav stickyClass="sticky-box-shadow" ngStickyNav>
  <div class="container-fluid">
    <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied">
      <a class="navbar-brand" routerLink="/"><img src="assets/images/logo_thmp.png" alt="logo"
          style="height: 40px;"></a>
      <button class="navbar-toggler" type="button" (click)="toggleClass()">
        <span class="burger-menu">
          <span class="top-bar"></span>
          <span class="middle-bar"></span>
          <span class="bottom-bar"></span>
        </span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item"><a routerLink="/" class="nav-link">Trang chủ</a>
          <li class="nav-item" *ngIf="currentUser.typeId == 1"><a routerLink="/tramdo" class="nav-link">Trạm đo</a>
          <li class="nav-item"><a routerLink="/bieudo" class="nav-link">Biểu đồ</a>
          <li class="nav-item"><a routerLink="/baocao" class="nav-link">Báo cáo</a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/bando']" routerLinkActive="router-link-active" class="nav-link">
              Bản đồ</a>
          </li>
          <li class="nav-item" *ngIf="currentUser.typeId == 1">
            <a [routerLink]="['/admin']" routerLinkActive="router-link-active" class="nav-link">
              Quản trị</a>
          </li>
          <li class="nav-item ">
            <a href="#" class="nav-link">Tài khoản</a>
            <ul class="dropdown-menu">
              <li class="nav-item"><a [routerLink]="['/profile']" routerLinkActive="router-link-active"
                  class="nav-link">
                  Thông tin cá nhân</a>
              </li>
              <li class="nav-item"><a href="#" routerLinkActive="router-link-active" class="nav-link"
                  (click)="logOut()">
                  Thoát</a>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="navbar-nav for-responsive">
          <li class="nav-item"><a routerLink="/" class="nav-link">Trang chủ</a>
          <li class="nav-item" *ngIf="currentUser.typeId == 1"><a routerLink="/tramdo" class="nav-link">Trạm đo</a>
          <li class="nav-item"><a routerLink="/bieudo" class="nav-link">Biểu đồ</a>
          <li class="nav-item"><a routerLink="/baocao" class="nav-link">Báo cáo</a>
          <li class="nav-item"><a [routerLink]="['/map']" routerLinkActive="router-link-active" class="nav-link">
              Bản đồ</a>
          </li>
          <li class="nav-item" *ngIf="currentUser.typeId == 1">
            <a [routerLink]="['/admin']" routerLinkActive="router-link-active" class="nav-link">
              Quản trị</a>
          </li>
          <li class="nav-item ">
            <a href="#" class="nav-link">Tài khoản</a>
            <ul class="dropdown-menu">
              <li class="nav-item"><a [routerLink]="['/profile']" routerLinkActive="router-link-active"
                  class="nav-link">
                  Thông tin cá nhân</a>
              </li>
              <li class="nav-item"><a href="#" routerLinkActive="router-link-active" class="nav-link"
                  (click)="logOut()">
                  Thoát</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>
